var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-table',{ref:"app-table",attrs:{"is-current-page":false,"page-size":2000,"table-props":{ 'max-height': '450px' },"table-key":_vm.table_key,"table-list-data":_vm.table_data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }